import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, apiError, setToken } from "../../lib/api";
import { Logo } from "../../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      nav("/admin");
    } catch (x) {
      setError(apiError(x));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wave-bg flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-md space-y-5 rounded-[1.6rem] border border-[#EDE3D9] bg-[#FFFDFB] p-10 shadow-xl" data-testid="admin-login-form">
        <Logo />
        <div className="flex items-center gap-2 pt-2 text-[#650D23]"><Lock className="h-4 w-4" /><h1 className="text-2xl">Espace administrateur</h1></div>
        <input type="email" required className="field-input" placeholder="Courriel" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
        <input type="password" required className="field-input" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
        {error && <p className="text-sm text-[#b42318]" role="alert" data-testid="admin-login-error">{error}</p>}
        <button className="btn-primary w-full" disabled={busy} data-testid="admin-login-submit">{busy ? "Connexion…" : "Se connecter"}</button>
      </form>
    </div>
  );
}
